import TopRightIcon from '../svg/TopRightIcon';
import PlusIcon from '../svg/PlusIcon';
import ArrowDownIcon from '../svg/ArrowDownIcon';

export default function NewsItem(props) {
  return (
    <div
      onClick={() => props.updateNotificationStatus(props._id)}
      className="flex items-center justify-between pl-2 py-2 pr-5 space-x-2.5 cursor-pointer hover:bg-gray-200"
    >
      <div className="w-full space-x-2.5 flex items-center">
        <div className="w-8 h-8 min-w-8 min-h-8 bg-[#E6EBF780] rounded-full flex items-center justify-center">
          {props.type == 'TRANSFERRED' && (
            <TopRightIcon size="w-[26px] h-[26px]" color="#2A59C6" />
          )}
          {props.type == 'RECHARGED' && (
            <PlusIcon size="w-[26px] h-[26px]" color="#2A59C6" />
          )}
          {props.type == 'FUND_RECEIVED' && (
            <ArrowDownIcon size="w-[26px] h-[26px]" color="#2A59C6" />
          )}
        </div>

        <div className="">
          <p className="text-xs text-[#252B37] font-medium leading-[20px]">
            {props.description}
          </p>
          <p className="text-[10px] text-[#717680] font-normal leading-[20px]">
            {props.sub_description}
          </p>
        </div>
      </div>

      <div className="min-w-15.5 text-[10px] text-[#717680] font-normal leading-[20px]">
        <p className="float-right">{props.created_at.slice(0, 10)}</p>
        <p className="float-right">{props.created_at.slice(11, 16)}</p>
      </div>
    </div>
  );
}
